import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Download, FileText, Loader2 } from 'lucide-react';
import { Button } from '../ui/button';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** PDF / CSV download of a server-rendered, country-specific tax form (VAT/GST return or WHT schedule). */
export const TaxReturnExportButtons = ({ endpoint, startDate, endDate, label = 'return', testIdPrefix = 'tax-export' }) => {
  const [busy, setBusy] = useState(null);
  const download = async (fmt) => {
    setBusy(fmt);
    try {
      const res = await axios.get(`${API}/unified-reports/${endpoint}/export`, {
        params: { format: fmt, start_date: startDate, end_date: endDate },
        responseType: 'blob',
      });
      const cd = res.headers['content-disposition'] || '';
      const name = (cd.match(/filename="([^"]+)"/) || [])[1] || `${endpoint}_${startDate}_${endDate}.${fmt}`;
      const url = URL.createObjectURL(res.data);
      const a = document.createElement('a');
      a.href = url; a.download = name; document.body.appendChild(a); a.click(); a.remove();
      URL.revokeObjectURL(url);
      toast.success(`${name} downloaded`);
    } catch (e) {
      let msg = e?.response?.data?.detail || e.message || 'Export failed';
      if (e?.response?.data instanceof Blob) { try { msg = JSON.parse(await e.response.data.text())?.detail || msg; } catch { /* ignore */ } }
      toast.error(typeof msg === 'string' ? msg : `Could not export the ${label}`);
    } finally {
      setBusy(null);
    }
  };
  return (
    <div className="flex items-center gap-2" data-testid={`${testIdPrefix}-buttons`}>
      <Button variant="outline" size="sm" onClick={() => download('pdf')} disabled={!!busy} data-testid={`${testIdPrefix}-pdf`}>
        {busy === 'pdf' ? <Loader2 className="w-4 h-4 mr-1 animate-spin" /> : <FileText className="w-4 h-4 mr-1" />}
        PDF {label}
      </Button>
      <Button variant="outline" size="sm" onClick={() => download('csv')} disabled={!!busy} data-testid={`${testIdPrefix}-csv`}>
        {busy === 'csv' ? <Loader2 className="w-4 h-4 mr-1 animate-spin" /> : <Download className="w-4 h-4 mr-1" />}
        CSV {label}
      </Button>
    </div>
  );
};

export default TaxReturnExportButtons;
